import Head from 'next/head'
import Script from 'next/script'
import { useContext } from 'react'
import { ContextoGlobal } from 'src/contexto/contextoGlobal'
import { useBlackFriday } from 'src/contexto/hooks/useBlackFriday'
import { isProduction } from 'src/util/isProduction'
import { API_KEY_LINX } from '../../util/config'
import { useCanonicalUrl } from 'src/contexto/hooks/useCanonicalUrl'

export const PREFIX_TITLE = 'Gazin |'

export const DEFAULT_TITLE = `${PREFIX_TITLE} Sua Loja de Telefonia, Eletrodomésticos e Muito Mais`
const DEFAULT_DESCRIPTION =
  'Encontre na Gazin uma ampla seleção de telefonia, eletrodomésticos e muito mais. Produtos de qualidade com os melhores preços do mercado. Acesse já!'

export default function InnerHead({
  linxMeta = '',
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  hasRobots = false,
}) {
  const { isBlackFridayTheme } = useBlackFriday()
  const { nonceValue } = useContext(ContextoGlobal)
  const AvatarTheo = isBlackFridayTheme ? 'blackfriday-theo.png' : 'theo.png'
  const ImageTheo = `${process.env.INTERNAL_IMAGES_URL}/images/png/${AvatarTheo}`

  const { canonicalUrl } = useCanonicalUrl()

  return (
    <>
      <Head>
        <title>{title}</title>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href={`${canonicalUrl}`} />
        <meta
          name="robots"
          content={`${
            isProduction() && hasRobots ? 'index, follow' : 'noindex, nofollow'
          }`}
        />
        <meta
          name="facebook-domain-verification"
          content="11eq6cuo7jyju4ygjsgc1ko5fn43p0"
        />
        <meta
          name="p:domain_verify"
          content="cf2270a95ea3c314f9479147d25f4d45"
        />
        <meta name="description" content={description} key="description" />
        <meta
          name="keywords"
          content="gazin, lojas gazin, gazin shop, moveis gazin, gazinshop, casas gazin, "
        />
        <meta name="author" content="TIG Maringá" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        {/* Facebook Sharing */}
        <meta
          property="og:site_name"
          content="Gazin - Loja de telefonia, eletrodomésticos e muito mais!"
          key="og:site_name"
        />
        <meta
          name="facebook-domain-verification"
          content="11eq6cuo7jyju4ygjsgc1ko5fn43p0"
        />
        <meta
          property="og:image:alt"
          content="Gazin - Loja de telefonia, eletrodomésticos e muito mais!"
        />
        <meta property="og:image" content={`${ImageTheo}`} key="og:image" />
        <meta
          property="og:image:secure_url"
          content={`${ImageTheo}`}
          key="og:image:secure_url"
        />
        <meta
          property="og:image:type"
          content="image/png"
          key="og:image:type"
        />
        <meta property="og:image:width" content="405px" key="og:image:width" />
        <meta
          property="og:image:height"
          content="417px"
          key="og:image:height"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} key="og:url" />
        <meta property="og:locale" content="pt_BR" />
        <meta charSet="utf-8" />
      </Head>

      {/* Script Linx */}
      {!!linxMeta && (
        <Script
          nonce={nonceValue}
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `window.linxMeta = ${JSON.stringify(linxMeta)}`,
          }}
        />
      )}
      <Script
        async
        defer
        nonce={nonceValue}
        src="//suite.linximpulse.net/impulse/impulse.js"
        data-apikey={API_KEY_LINX}
      />

      {/* Trust Logo */}
      <Script
        async
        defer
        nonce={nonceValue}
        src="https://secure.trust-provider.com/trustlogo/javascript/trustlogo.js"
        type="text/javascript"
      />
    </>
  )
}
